














































































import {Component} from 'vue-property-decorator';
import Slide from '@/presentation/slides/Slide';
import CompassIndustry from '@/components/CompassIndustry.vue';
import CompassCompetitors from '@/components/CompassCompetitors.vue';
import SustainabilityCompass from '@/charts/SustainabilityCompass.vue';
import ExtendedCompass from '@/components/ExtendedCompass.vue';

@Component({components: {ExtendedCompass, SustainabilityCompass, CompassCompetitors, CompassIndustry}})
export default class CompassNewSlide extends Slide {
  hovered: any | null = null;

  onHoverChanged(e: any) {
    this.hovered = e;
  }

  get subTypes() {
    return ['', 'growth'];
  }
}
